import { forwardRef, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import cn from 'classnames';

import { type DiceGameCardProps } from '@/common/types/dice-game';
import { Picture } from '@/components/ui/Picture/Picture';
import { setBombImagePosition } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch } from '@/redux/store';

import { ActiveBorder } from '../ActiveBorder/ActiveBorder';

import css from './styles.module.scss';

import bombPng from '/img/dice-game/bomb.png';
import bombWebp from '/img/dice-game/bomb.webp';
import redBgPng from '/img/dice-game/red-card-bg.png';
import redBgWebp from '/img/dice-game/red-card-bg.webp';

const BombCard = forwardRef<HTMLDivElement, DiceGameCardProps>(
  ({ isActive, ...props }, ref) => {
    const [bombRef, bombMeasure] = useMeasure();
    const dispatch = useAppDispatch();

    useEffect(() => {
      if (bombMeasure.x && bombMeasure.y) {
        const { x, y } = bombMeasure;
        dispatch(setBombImagePosition({ x, y }));
      }
    }, [bombMeasure]);

    return (
      <div ref={ref} {...props} className={cn(css.bombCard, props.className)}>
        <div className="absolute overflow-hidden rounded-xl top-0 left-0 w-full h-full">
          <Picture
            className="w-full h-full"
            img={redBgPng}
            webp={redBgWebp}
            alt="light"
          />
        </div>
        <Picture
          ref={bombRef}
          className="relative z-[1] -translate-y-[0.375rem] w-[63.71%] h-[63.71%]"
          img={bombPng}
          webp={bombWebp}
          alt="bomb"
        />
        {isActive && <ActiveBorder variant="red" />}
      </div>
    );
  },
);

export { BombCard };
